import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size, rgba } from '../layout/helpers';

export const PromotionSliderWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const Slider = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  text-align: center;
  white-space: nowrap;
  scroll-snap-type: x mandatory;

  @supports (-moz-appearance: none) {
    overflow: hidden;
  }

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 0;
  }

  ${theme.screens.LtMd} {
    margin: 0 ${size(-2)};
    padding: 0 ${size(1)};

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      height: ${size(2.25)};
      margin: 0 ${size(2)};
    }

    &::-webkit-scrollbar-track {
      background-color: ${rgba(theme.colors.bg.alt, 0.1)};
      height: ${size(0.25)};
      margin: 0 ${size(2)};
      border-top: ${size(2)} solid transparent;
      background-clip: padding-box;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.bg.alt};
      height: ${size(0.25)};
      border-top: ${size(2)} solid transparent;
      background-clip: padding-box;
    }
  }
`;

interface SliderItemProps {
  desktopColumns: number;
}

export const SliderItem = styled.a<SliderItemProps>`
  display: inline-block;
  white-space: normal;
  width: 72vw;
  scroll-snap-align: start;
  text-align: left;
  vertical-align: top;
  padding: 0 ${size(1)};

  ${theme.screens.LtMd} {
    scroll-margin-left: ${size(1)};
  }

  ${theme.screens.Md} {
    width: ${({ desktopColumns }) => `${100 / desktopColumns}%`};
  }
`;

export const NavContainer = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  pointer-events: none;

  ${theme.screens.LtMd} {
    display: none;
  }
`;

const NavButton = styled.button`
  position: absolute;
  border-radius: 50%;
  background: ${theme.colors.button.base.default};
  color: ${theme.colors.button.base.text};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 125ms;
  top: calc(50% - ${size(2.5)});
  width: ${size(5)};
  height: ${size(5)};
  pointer-events: all;

  svg {
    font-size: 24px;
  }
`;

export const NavLeft = styled(NavButton)`
  left: ${size(-2)};
`;

export const NavRight = styled(NavButton)`
  right: ${size(-2)};
`;

export const Headline = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;

  ${theme.screens.Lg} {
    font-size: 20px;
  }
`;

export const Subline = styled.div`
  font-size: 24px;
  font-weight: 700;
  display: inline-block;
  margin-right: ${size(1)};
  line-height: 1.25;

  ${theme.screens.Lg} {
    font-size: 32px;
  }
`;

export const Subtail = styled.div`
  font-size: 16px;
  display: inline-block;
`;
